<template lang="pug">
.cs-home.d-flex
  .sidebar.scrollable.py-3.pl-3.pr-2
    CSUserStatPanel(
      :user='user'
      :notificationCount='notificationCount'
      @reloadAfterError='loadCurrentUser()'
    )
    GenericCard.pt-3(size='33')
      MenuItem(title='ทำรายการขาย' @click="$router.push('/cs/new-order')")
      MenuItem(title='ดูรายการขาย' @click="$router.push('/cs/sell-record')")
      MenuItem(title='ดูประวัติลูกค้า' @click="$router.push('/cs/customer-history')")
      MenuItem(title='ตั้งค่าบัญชีส่วนตัว' @click="$router.push('/cs/settings')")
      MenuItem(title='พิมพ์รายงาน' @click="$router.push('/cs/print')")
      MenuItem(title='ออกจากระบบ' @click="$store.dispatch('logout')")

  .content.scrollable
    .py-3.pr-2.pl-0(v-if='user.stat')
      //- outstanding, dueToday, backOrder, awaitShipment
      .d-flex.flex-wrap
        template(v-for='(title, key) in statFields')
          StatItem(
            :key='key'
            :title='title'
            :badgeNumber='user.stat[key] ? user.stat[key].count : `...`'
            :value='user.stat[key] ? user.stat[key].total : `...`'

            :highlighted='key === selectedStatItem'
            @click='onStatItemSelected(key)'
          )

      //- dueList
      .flex-fill.pt-2.pb-3
        div(v-show='selectedStatItem === `pendingOrder`')
          CSPendingOrderList(
            @finishLoading='tableDataLoaded(`pendingOrder`, $event)'
          )
        div(v-show='selectedStatItem === `outstanding`')
          OutstandingList(
            @finishLoading='tableDataLoaded(`outstanding`, $event)'
          )
        div(v-show='selectedStatItem === `backOrder`')
          CSBackOrderList(
            @finishLoading='tableDataLoaded(`backOrder`, $event)'
          )
        div(v-show='selectedStatItem === `awaitShipment`')
          AwaitShipmentList(
            @finishLoading='tableDataLoaded(`awaitShipment`, $event)'
          )
        //- template(v-else)
        //-   GenericCard(size='auto')
        //-     .px-4.py-3
        //-       .text-large {{ selectedStatItem }}

  NotificationPanel(
    style='position: fixed; top: 0; width: 100%'
    @dataLoaded='notifications = $event'
    @itemClicked='showOrderDetail'
  )

</template>

<script>
/* eslint-disable arrow-body-style */
import CSUserStatPanel from '@/components/_cs/dashboard/CSUserStatPanel.vue';
import NotificationPanel from '@/components/_dialogs/NotificationPanel.vue';

import CSPendingOrderList from '@/components/_cs/dashboard/panels/CSPendingOrderList.vue';
import OutstandingList from '@/components/dashboard/panels/OutstandingList.vue';
// import DueTodayList from '@/components/dashboard/panels/DueTodayList.vue';
import CSBackOrderList from '@/components/_cs/dashboard/panels/CSBackOrderList.vue';
import AwaitShipmentList from '@/components/dashboard/panels/AwaitShipmentList.vue';

export default {
  data: () => ({
    user: {},
    statFields: {
      pendingOrder: 'รายการรออนุมัติ',
      outstanding: 'รายการค้างชำระ',
      backOrder: 'รายการตกค้าง(backorder)',
      awaitShipment: 'รายการรอจัดส่ง',
    },
    selectedStatItem: 'pendingOrder',

    notifications: [],
    notificationCount: null,
  }),
  watch: {
    notifications: {
      deep: true,
      handler() {
        // recalculate notificationCount
        this.notificationCount = this.notifications.reduce((total, notif) => {
          if (notif.read === 0) return total + 1;
          return total;
        }, 0);
      },
    },
  },
  mounted() {
    this.loadCurrentUser();
  },
  methods: {
    async showOrderDetail(notification) {
      // alert(JSON.stringify(notification));
      const { order_id: orderId } = notification;

      try {
        const res = await this.$api.order.getWithId(orderId);

        this.$router.push({
          name: 'cs.sell-record', // can't use path, cause it WON'T allow passing hidden params
          params: {
            order: res.data,
            actionType: 'SELL_LIST',
            // ...e, // pass everything in, LOL
          },
        });
        console.log(res);
      } catch (e) {
        console.log(e);
      }
    },

    async loadCurrentUser() {
      this.isLoading = true;

      const res = await this.$api.cs.user.current();
      if (res.status === 200) {
        this.user = res.data;
      }

      this.isLoading = false;
    },
    onStatItemSelected(statItemKey) {
      // alert(e);
      this.selectedStatItem = statItemKey;
    },

    tableDataLoaded(key, elm) {
      console.log(elm);
      this.user.stat[key] = {
        count: elm.total,
        // total: (
        //   elm.reduce((total, order) => (total + Number(order.total)), 0)
        // ),
      };
    },
  },
  components: {
    CSUserStatPanel,
    NotificationPanel,

    CSPendingOrderList,
    OutstandingList,
    // DueTodayList,
    CSBackOrderList,
    AwaitShipmentList,
  },
};
</script>

<style lang="scss">
.cs-home {
  // max-width: 1200px;
  margin: 0 auto;

  .sidebar {
    // ...
  }
  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .generic-card {
    // padding-left: 0;
    // padding-bottom: 0;
    padding: 8px;
  }
}
</style>
